// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__V3UHq","bold":"style_bold__PBOY3","location":"style_location__LuS46","label":"style_label__yFbsM"};